import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0a02f3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-bespoke-long-covid-definitions" }
const _hoisted_2 = { class: "hd-bespoke-long-covid-definitions__container" }
const _hoisted_3 = { class: "hd-bespoke-long-covid-definitions__item" }
const _hoisted_4 = { class: "hd-bespoke-long-covid-definitions__item" }
const _hoisted_5 = { class: "hd-bespoke-long-covid-definitions__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!
  const _component_base_image_svg = _resolveComponent("base-image-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_lyra_asset, {
      class: "hd-title",
      "asset-key": `${_ctx.endpointId}.title`
    }, null, 8, ["asset-key"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_base_image_svg, {
          source: require('@/applications/covid-hub/ui/assets/bespoke/long-covid-definitions-image-left.png'),
          "is-image": true
        }, null, 8, ["source"]),
        _createVNode(_component_lyra_asset, {
          class: "hd-bespoke-long-covid-definitions__item-content",
          "asset-key": `${_ctx.endpointId}.text-left`
        }, null, 8, ["asset-key"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_base_image_svg, {
          source: require('@/applications/covid-hub/ui/assets/bespoke/long-covid-definitions-image-center.png'),
          "is-image": true
        }, null, 8, ["source"]),
        _createVNode(_component_lyra_asset, {
          class: "hd-bespoke-long-covid-definitions__item-content",
          "asset-key": `${_ctx.endpointId}.text-center`
        }, null, 8, ["asset-key"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_base_image_svg, {
          source: require('@/applications/covid-hub/ui/assets/bespoke/long-covid-definitions-image-right.png'),
          "is-image": true
        }, null, 8, ["source"]),
        _createVNode(_component_lyra_asset, {
          class: "hd-bespoke-long-covid-definitions__item-content",
          "asset-key": `${_ctx.endpointId}.text-right`
        }, null, 8, ["asset-key"])
      ])
    ])
  ]))
}